
interface UserProfile {
  user_id: string;
  first_name: string | null;
  display_name: string | null;
}

export const getDisplayName = (profile: UserProfile | null): string => {
  if (!profile) return '';
  return profile.display_name || profile.first_name || 'User';
};
